import { useMemo } from "react"

import { sum } from "shared/lib/arrayUtils"

import { getProductTotal } from "entities/projects/lib/getProductTotal"
import { useRoomMultiActions } from "features/room-management/model/useRoomMultiActions"

import { RoomMultiSelectSidebarModel } from "../RoomMultiSelectSidebar"
import { RoomMultiSelectSidebarViewModel } from "../RoomMultiSelectSidebarView"

export function useRoomMultiSelectSidebarViewModel({
  rooms,
  callbacks,
  isDisabled,
  ...rest
}: RoomMultiSelectSidebarModel): RoomMultiSelectSidebarViewModel {
  const productTotal = useMemo(
    () => sum(rooms, room => getProductTotal(room.children)),
    [rooms]
  )

  const { actions } = useRoomMultiActions({
    ...callbacks,
    isDeleteDisabled: isDisabled
  })

  return {
    ...rest,
    productTotal,
    actions,
    selectedChildCount: rooms.length
  }
}
